import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "app"
};
import { computed, defineAsyncComponent, ref } from 'vue';
import { useRoute } from 'vue-router';
export default {
  __name: 'App',
  setup(__props) {
    const FloatingAgentButton = defineAsyncComponent(() => import(/* webpackChunkName: "agent-floating-button" */
    '@/components/ai-agent/FloatingAgentButton.vue'));
    const AgentChatPanel = defineAsyncComponent(() => import(/* webpackChunkName: "agent-chat-panel" */
    '@/components/ai-agent/AgentChatPanel.vue'));
    const isAgentPanelVisible = ref(false);
    const hasLoadedAgentPanel = ref(false);
    const route = useRoute();
    const isAgentRoute = computed(() => route.path === '/agent');
    const isMobileRoute = computed(() => route.path === '/mobile' || route.path.startsWith('/mobile/'));
    const hideAgentButton = computed(() => route.meta.hideAgentButton === true);
    const toggleAgentPanel = () => {
      const nextVisible = !isAgentPanelVisible.value;
      if (nextVisible) {
        // 单向挂载：首开才下载重依赖，关闭后保留会话与语音输入状态。
        hasLoadedAgentPanel.value = true;
      }
      isAgentPanelVisible.value = nextVisible;
    };
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view), !isMobileRoute.value && !isAgentRoute.value && !hideAgentButton.value ? (_openBlock(), _createBlock(_unref(FloatingAgentButton), {
        key: 0,
        onToggle: toggleAgentPanel
      })) : _createCommentVNode("", true), !isMobileRoute.value && !isAgentRoute.value && !hideAgentButton.value && hasLoadedAgentPanel.value ? (_openBlock(), _createBlock(_unref(AgentChatPanel), {
        key: 1,
        modelValue: isAgentPanelVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => isAgentPanelVisible.value = $event)
      }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]);
    };
  }
};